import { render, staticRenderFns } from "./NewBooking.vue?vue&type=template&id=2f42c519&scoped=true"
import script from "./NewBooking.vue?vue&type=script&lang=js"
export * from "./NewBooking.vue?vue&type=script&lang=js"
import style0 from "./NewBooking.vue?vue&type=style&index=0&id=2f42c519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f42c519",
  null
  
)

export default component.exports